import { createRouter, createWebHistory } from 'vue-router'
import { useUserStoreWithOut } from '@/store/modules/user'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginPage.vue'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/RegisterPage.vue'),
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPasswordPage.vue'),
    },
    {
      path: '/workbench',
      name: 'workbench',
      meta: { requiresAuth: true },
      component: () => import('@/views/WorkbenchPage.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      meta: { requiresAuth: true },
      component: () => import('@/views/ProfilePage.vue'),
    },
    {
      path: '/messages',
      name: 'messages',
      meta: { requiresAuth: true },
      component: () => import('@/views/MessagesPage.vue'),
    },
    {
      path: '/change-password',
      name: 'change-password',
      meta: { requiresAuth: true },
      component: () => import('@/views/ChangePasswordPage.vue'),
    },
    {
      path: '/project/:id',
      name: 'project-detail',
      meta: { requiresAuth: true },
      component: () => import('@/views/ProjectDetailPage.vue'),
    },
    {
      path: '/storyboard',
      name: 'storyboard',
      meta: { requiresAuth: true },
      component: () => import('@/views/StoryboardPage.vue'),
    },
    {
      path: '/team',
      name: 'team',
      meta: { requiresAuth: true },
      component: () => import('@/views/TeamManagementPage.vue'),
    },
    {
      path: '/invoice',
      name: 'invoice',
      meta: { requiresAuth: true },
      component: () => import('@/views/InvoicePage.vue'),
    },
    {
      path: '/purchase',
      name: 'purchase',
      meta: { requiresAuth: true },
      component: () => import('@/views/PurchaseCoinsPage.vue'),
    },
    {
      path: '/transactions',
      name: 'transactions',
      meta: { requiresAuth: true },
      component: () => import('@/views/TransactionHistoryPage.vue'),
    },
    {
      path: '/recharges',
      name: 'recharges',
      meta: { requiresAuth: true },
      component: () => import('@/views/RechargeHistoryPage.vue'),
    },
    {
      path: '/assets',
      name: 'assets',
      meta: { requiresAuth: true },
      component: () => import('@/views/AssetsPage.vue'),
    },
    {
      path: '/assets/:type',
      name: 'asset-category',
      meta: { requiresAuth: true },
      component: () => import('@/views/AssetCategoryPage.vue'),
    },
  ],
})

// 无需登录即可访问的白名单
const whiteList = NO_REDIRECT_WHITE_LIST

router.beforeEach((to) => {
  const userStore = useUserStoreWithOut()
  const token = userStore.getToken

  if (token) {
    // 已登录
    if (to.path === '/login') {
      // 已登录访问登录页 → 跳到工作台
      return '/workbench'
    }
    return
  }

  // 未登录
  if (whiteList.includes(to.path)) {
    return
  }
  // 其他页面 → 跳转登录页，携带 redirect 参数
  return `/login?redirect=${encodeURIComponent(to.fullPath)}`
})

export default router
